import { IPlanFeature } from '@/shared/model/plan-feature.model';
import { IProduct } from './product.model';

export const enum PlanInterval {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export interface IPlan {
  id?: number;
  name?: string;
  nickname?: string;
  description?: string;
  amount?: number;
  interval?: PlanInterval;
  intervalCount?: number;
  active?: boolean;
  stripeId?: string;
  createdDate?: Date;
  lastModifiedDate?: Date;
  createdBy?: string;
  lastModifiedBy?: string;
  products?: IProduct[];
  planFeatures?: IPlanFeature[];
  hubSpotSku?: string;
  itemCode?: string;
  trialNickname?: string;
  hasLearners?: boolean;
  freeWithPaid?: boolean;
  freeWithTrial?: boolean;
  internal?: boolean;
  relatedPlans?: string;
}

export class Plan implements IPlan {
  constructor(
    public id?: number,
    public name?: string,
    public nickname?: string,
    public description?: string,
    public amount?: number,
    public interval?: PlanInterval,
    public intervalCount?: number,
    public active?: boolean,
    public stripeId?: string,
    public createdDate?: Date,
    public lastModifiedDate?: Date,
    public createdBy?: string,
    public lastModifiedBy?: string,
    public product?: IProduct[],
    public planFeatures?: IPlanFeature[],
    public hubSpotSku?: string,
    public itemCode?: string,
    public trialNickname?: string,
    public hasLearners?: boolean,
    public freeWithPaid?: boolean,
    public freeWithTrial?: boolean,
    public internal?: boolean,
    public relatedPlans?: string,
  ) {
    this.active = this.active || false;
    this.hasLearners = this.hasLearners || false;
    this.freeWithPaid = this.freeWithPaid || false;
    this.freeWithTrial = this.freeWithTrial || false;
    this.internal = this.internal || false;
  }
}
